/**
 * Laravel's boolean validator expects '1' or '0' as values; you can use
 * this to convert received boolean values to '1' or '0' for validation.
 *
 * @param {boolean} value
 * @returns {number}
 */
function booleanToIntNullable(value) {
  if (value === null) {
    return null
  }
  return value ? 1 : 0
}

/**
 * See above; this can convert integer values back to boolean values, for
 * easier handling within frontend components.
 *
 * @param {number} value
 * @returns {boolean}
 */
function intToBooleanNullable(value) {
  if (value === null) {
    return null
  }
  return value !== 0
}

const ValueNormalisers = {
  booleanToIntNullable,
  intToBooleanNullable,
}

export default ValueNormalisers

export { booleanToIntNullable, intToBooleanNullable }
